import React, { useContext, useCallback, useState, useMemo } from "react";
import { StyleSheet, View, Image, Text, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome5";
import Row from "../../../layouts/Row";
import Col from "../../../layouts/Col";
import Heading from "../../Heading";
import palette from "~/styles/palette";
import ExpandableCard from "../../ExpandableCard/index.web";
import ParticipantContext from "../../../contexts/ParticipantContext";
import dayjs from "../../../helpers/day";

export default function ParticipantFiles() {
  const { customer, getCustomer } = useContext(ParticipantContext);
  const { files = [] } = customer || {};
  if (!customer) return null;

  return (
    <ExpandableCard
      title="Files"
      icon="paperclip"
      badge={files?.length}
      onOpen={getCustomer}
    >
      <Row>
        {files.map((file, x) => (
          <FileTile key={x} {...file} />
        ))}
      </Row>
    </ExpandableCard>
  );
}

const FileTile = ({ mime_type, ...props }) => {
  if (mime_type == "image/jpeg") return <ImageTile {...props} />;
  if (mime_type == "image/png") return <ImageTile {...props} />;
  return <MimeTypeTile mimeType={mime_type} {...props} />;
};

const ImageTile = ({ url }) => {
  return (
    <View style={[styles.participant_details__files__file_tile]}>
      <Image source={url} style={[styles.participant_details__files__image]} />
    </View>
  );
};

const MimeTypeTile = ({ mimeType: mime_type, url, ...props }) => {
  const iconName = useMemo(() => {
    switch (mime_type) {
      case "application/pdf": {
        return "file-pdf";
      }

      default:
        return "";
    }
  }, [mime_type]);

  const onPress = () => {
    window.open(`https://cdn.fieldpulse.com/${props.s3_path}`, "_blank").focus();
  };

  return (
<TouchableOpacity onPress={onPress} style={{width: '100%'}}>
    <Row pl={8} pr={8}>
      <Col leftCenter size={2}>
        <View style={[styles.participant_details__files__file_tile]}>
          <Icon
            name={iconName}
            size={32}
            style={{ padding: 8 }}
            color={palette.dark}
          />
        </View>
      </Col>

      <Col Center>
        <Heading size={5} ml={0}>
          {props.display_name}
        </Heading>

          <Text
            numberOfLines={1}
            style={[styles.participant_details__invoice__item_day]}
          >
            {dayjs(props.created_at).format("h:mm A - ddd, MMM Do")}
          </Text>
      </Col>
    </Row>
</TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  participant_details__files__container: {
    fontWeight: "500",
    color: palette.grey,
    paddingHorizontal: 16,
    borderColor: palette.lighter_grey,
    borderBottomWidth: 1,
    overflow: "hidden",
    transitionDuration: "150ms",
    transitionProperty: "height",
    transitionTimingFunction: "ease-out",
    height: 320,
  },
  participant_details__files__file_tile: {
    backgroundColor: palette.light_grey,
    margin: 3,
    borderRadius: 4,
    overflow: "hidden",
  },
  participant_details__files__image: {
    height: 105,
    width: 105,
  },

  participant_details__invoice__item_day: {
    fontSize: 16,
    fontWeight: "600",
    color: palette.grey,
  },
});
